<button matIconButton type="button" class="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<h4 mat-dialog-title>
  {{ data.title ? data.title : ("file-downloader.defaultTitle" | translate) }}
</h4>
<form #fileDownloadForm="ngForm" (ngSubmit)="(false)" novalidate>

  <mat-dialog-content>
    @if (data.description?.length > 0 || false) {
      <div class="description">{{data.description}}</div>
    }
    <div class="fileNameContainer">
      <mat-form-field  appearance="outline">
        <mat-label>{{ "file-downloader.projection" | translate }}</mat-label>
        <mat-select [ngModel]="getCheckedProjection()" name="projection" #projection>
          @for (enumValue of fileDownloaderSupportedProjectionTypes(); track enumValue) {
            <mat-option [value]="enumValue">
              {{enumValue}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- EPSG:4326 (wgs 84) -->
      <mat-form-field  appearance="outline" [ngClass]="{'hidden': data.selectedFileType && data.selectedFileTypeOnly}">
        <mat-label>{{ "file-downloader.filetype" | translate }}</mat-label>
        <mat-select [ngModel]="data.selectedFileType ? data.selectedFileType : defaultFileType" name="filetype" #filetype>
          @for (enumValue of fileDownloaderSupportedFileTypes(); track enumValue) {
            <mat-option [value]="enumValue">
              {{enumValue}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field  appearance="outline" hintLabel="{{ 'file-downloader.max-length' | translate }} 100" required>
        <mat-label>{{ "file-downloader.filename" | translate }}</mat-label>
        <input matInput type="text" name="filename" #filename [ngModel]="data.fileName ? data.fileName : fileNameSuggestion" [pattern]="'^((?!\\s{2})[A-Za-zÀ-ÿ0-9\\s_\\-()\\[\\]]){1,100}$'" />
        <mat-hint align="end">{{ filename.value?.length || 0 }}/100</mat-hint>
      </mat-form-field>
      <div class="fileNameExtension"><span>.</span>{{ filetype.value }}</div>
    </div>
    <div class="fileTypeDescipionContainer">
      {{ ("file-downloader.file-type-desc." + filetype.value) | translate }}
    </div>
    @if (errorMessage) {
      <div class="downloadError">
        {{errorMessage}}
      </div>
    }

  </mat-dialog-content>
  <!-- <div mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{"general.close" | translate | uppercase}}</button>
  <button mat-stroked-button (click)="downloadFile()" [ngClass]="{'mat-button-disabled': !fileDownloadForm.valid}" [disabled]="!fileDownloadForm.valid">{{"file-downloader.download" | translate | uppercase}}</button>
</div> -->

<mat-dialog-actions align="center" class="">
  <div class="button-container">
    <!-- <div class="form-element"> -->
    <button mat-flat-button
      color="primary"
      (click)="downloadFile()"
      [ngClass]="{'mat-button-disabled': !fileDownloadForm.valid}"
      [disabled]="!fileDownloadForm.valid" type="submit">
      <mat-icon aria-label="map">file_download</mat-icon>&nbsp;&nbsp;{{"file-downloader.download" | translate }}
    </button>
  <!-- </div> -->
</div>
<div class="button-container">
  <a [mat-dialog-close]="[fileDownloadForm.value,fileDownloadForm.dirty]" mat-dialog-close
  class="close-tip">&nbsp;{{"general.close"|translate}}</a>
</div>
</mat-dialog-actions>

</form>